module.exports = __webpack_public_path__ + "static/media/project.28a6b02f.svg";